<c-input-group class="flex-nowrap p-2">
  @if (showIcon) {
    <span class="input-group-text">
      <i [ngClass]="`${iconsStyle} ${iconSize} ${icons.lock}`"></i>
    </span>
  }
  <input
    [type]="fieldTextType ? 'text' : 'password'"
    [(ngModel)]="value"
    (input)="onInput(getInputValue($event))"
    (keyup)="onKeyup($event)"
    required
    class="form-control"
    autocomplete="off"
    [placeholder]="placeholder | translate"
  />
  @if (showVisibilityToggle) {
    <i
      class="icon-password-visibility fa"
      [ngClass]="{
        'fa-eye-slash': !fieldTextType,
        'fa-eye': fieldTextType,
      }"
      (mousedown)="toggleFieldTextType(true)"
      (mouseup)="toggleFieldTextType(false)"
    ></i>
  }
</c-input-group>
